import { gsap } from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { Draggable } from "gsap/Draggable";

gsap.registerPlugin(ScrollToPlugin, ScrollTrigger, Draggable);

document.addEventListener('DOMContentLoaded', () => {


    // Hero text — page-load fade-up (no ScrollTrigger needed)
    const heroTitle    = document.querySelector('#wrapper-hero .hero-title');
    const heroSubtitle = document.querySelector('#wrapper-hero .hero-subtitle');

    if (heroTitle || heroSubtitle) {
        const tl = gsap.timeline({ delay: 0.2 });

        if (heroTitle) {
            tl.from(heroTitle, {
                duration: 0.8,
                autoAlpha: 0,
                y: 40,
                ease: 'power2.out',
            });
        }

        if (heroSubtitle) {
            tl.from(heroSubtitle, {
                duration: 0.7,
                autoAlpha: 0,
                y: 30,
                ease: 'power2.out',
            }, '-=0.4');
        }
    }


    // .hwhat-boxes — staggered fade-up per column on scroll
    document.querySelectorAll('.hwhat-boxes').forEach((row) => {
        const cols = row.querySelectorAll(':scope > .wp-block-column');
        if (!cols.length) return;

        gsap.from(cols, {
            scrollTrigger: {
                trigger: row,
                start: 'top 82%',
                toggleActions: 'play none none none',
            },
            duration: 0.65,
            autoAlpha: 0,
            y: 40,
            ease: 'power2.out',
            stagger: 0.15,
        });
    });

	// .product-cols — staggered fade-up per column on scroll
    document.querySelectorAll('.product-cols').forEach((row) => {
        const cols = row.querySelectorAll(':scope > .wp-block-column');
        if (!cols.length) return;

        gsap.from(cols, {
            scrollTrigger: {
                trigger: row,
                start: 'top 82%',
                toggleActions: 'play none none none',
            },
            duration: 0.65,
            autoAlpha: 0,
            y: 40,
            ease: 'power2.out',
            stagger: 0.15,
        });
    });

	// .cols-boxes — staggered fade-up per column on scroll
    document.querySelectorAll('.cols-boxes').forEach((row) => {
        const cols = row.querySelectorAll(':scope > .wp-block-column');
        if (!cols.length) return;

        gsap.from(cols, {
            scrollTrigger: {
                trigger: row,
                start: 'top 82%',
                toggleActions: 'play none none none',
            },
            duration: 0.65,
            autoAlpha: 0,
            y: 40,
            ease: 'power2.out',
            stagger: 0.15,
        });
    });

	// .cols-productsboxfull — fade-up the element itself on scroll
    document.querySelectorAll('.cols-productsboxfull').forEach((el) => {
        gsap.from(el, {
            scrollTrigger: {
                trigger: el,
                start: 'top 82%',
                toggleActions: 'play none none none',
            },
            duration: 0.65,
            autoAlpha: 0,
            y: 40,
            ease: 'power2.out',
        });
    });

	// .cols-productsboxes — staggered fade-up per column on scroll
    document.querySelectorAll('.cols-productsboxes').forEach((row) => {
        const cols = row.querySelectorAll(':scope > .wp-block-column');
        if (!cols.length) return;

        gsap.from(cols, {
            scrollTrigger: {
                trigger: row,
                start: 'top 82%',
                toggleActions: 'play none none none',
            },
            duration: 0.65,
            autoAlpha: 0,
            y: 40,
            ease: 'power2.out',
            stagger: 0.15,
        });
    });

	// section-printing-capabilities — staggered fade-up per column on scroll
    document.querySelectorAll('.section-printing-capabilities').forEach((row) => {
        const cols = row.querySelectorAll('.capabilities-box');
        if (!cols.length) return;

        gsap.from(cols, {
            scrollTrigger: {
                trigger: row,
                start: 'top 82%',
                toggleActions: 'play none none none',
            },
            duration: 0.65,
            autoAlpha: 0,
            y: 40,
            ease: 'power2.out',
            stagger: 0.25,
        });
    });

		// .cols-boximg — staggered fade-up per column on scroll
    document.querySelectorAll('.cols-boximg').forEach((row) => {
        const cols = row.querySelectorAll(':scope > .wp-block-column');
        if (!cols.length) return;

        gsap.from(cols, {
            scrollTrigger: {
                trigger: row,
                start: 'top 82%',
                toggleActions: 'play none none none',
            },
            duration: 0.65,
            autoAlpha: 0,
            y: 40,
            ease: 'power2.out',
            stagger: 0.15,
        });
    });

    // .group-bannerlg h2 — count up numbers from 0 when scrolled into view.
    // The span (% sign) is a separate DOM node so it stays untouched; only
    // the text node containing the number is updated on each frame.
    document.querySelectorAll('.section-bannerhighlights .group-bannerlg h2').forEach((h2) => {
        // Find the text node that holds the numeric value
        let numberNode = null;
        h2.childNodes.forEach((node) => {
            if (node.nodeType === Node.TEXT_NODE && /[\d.]/.test(node.textContent)) {
                numberNode = node;
            }
        });
        if (!numberNode) return;

        const raw    = numberNode.textContent.trim();
        const target = parseFloat(raw);
        if (isNaN(target)) return;

        const decimals = raw.includes('.') ? raw.split('.')[1].length : 0;
        const counter  = { value: 0 };

        gsap.to(counter, {
            scrollTrigger: {
                trigger: h2,
                start: 'top 85%',
                toggleActions: 'play none none none',
            },
            value: target,
            duration: 2,
            ease: 'power2.out',
            onUpdate() {
                numberNode.textContent = decimals > 0
                    ? counter.value.toFixed(decimals)
                    : Math.round(counter.value);
            },
        });
    });


    // Fade up elements animation
    const fadeUpElements = document.querySelectorAll('.anmi-fadeup');
    fadeUpElements.forEach((element, index) => {
        gsap.from(element, {
            scrollTrigger: {
                trigger: element,
                start: 'top 80%',
                toggleActions: 'play none none none',
            },
            duration: 1,
            opacity: 0,
            y: 50,
            ease: 'power2.out',
            stagger: 0.15,
            delay: index * 0.15
        });
    });


    // Journey section — one timeline for the whole section so rows play
    // strictly in sequence (row 2 only starts after row 1 finishes),
    // regardless of whether both rows are already in the viewport.
    const journeyBody = document.querySelector('.body-hjourney');
    if (journeyBody) {
        const rows = journeyBody.querySelectorAll('.wp-block-columns');

        const tl = gsap.timeline({
            scrollTrigger: {
                trigger: journeyBody,
                start: 'top 82%',
                toggleActions: 'play none none none',
            },
        });

        let rowOffset = 0; // tracks when the previous row finishes

        rows.forEach((row) => {
            const groups = row.querySelectorAll('.journey-group');
            if (!groups.length) return;

            let rowEndTime = rowOffset;

            groups.forEach((group, i) => {
                const image   = group.querySelector('figure, .wp-block-image');
                const textEls = group.querySelectorAll('h3, p');
                const groupStart = rowOffset + i * 0.28;

                if (image) {
                    tl.from(image, {
                        duration: 0.55,
                        autoAlpha: 0,
                        y: 35,
                        ease: 'power2.out',
                    }, groupStart);
                    rowEndTime = Math.max(rowEndTime, groupStart + 0.55);
                }

                if (textEls.length) {
                    const textStart    = groupStart + 0.18;
                    const textDuration = 0.5 + (textEls.length - 1) * 0.1;
                    tl.from(textEls, {
                        duration: 0.5,
                        autoAlpha: 0,
                        y: 22,
                        ease: 'power2.out',
                        stagger: 0.1,
                    }, textStart);
                    rowEndTime = Math.max(rowEndTime, textStart + textDuration);
                }
            });

            // Next row starts 0.15s after this row's last tween ends
            rowOffset = rowEndTime + 0.15;
        });
    }


});

export default function initInitGsap() {
    gsap.registerPlugin(ScrollTrigger, Draggable);
}

